import type { Surface } from '@littlebird/action-cards-view';

// The card's tinted frame is Littlebird's; the app's object sits on a white inset inside it.
// `ac-scale` turns on the card's sizes (registry/cardScale.css)
export const CARD_FRAME =
  'ac-scale w-full overflow-hidden rounded-[calc(12*var(--ac-u))] border border-border bg-secondary p-[var(--ac-pad-frame)]';

// The feed's frame has no box of its own: its header is the row it opened from, and its body is drawn
// as one card (feed/feed.css). The transparent 1px border keeps the header where the row's border put it
export const FEED_FRAME =
  'ac-scale feed-frame relative mx-[calc(-1*var(--ac-frame-bleed))] flex w-[calc(100%+2*var(--ac-frame-bleed))] min-w-0 flex-col gap-[var(--ac-frame-gap)] rounded-[var(--ac-frame-radius)] border border-transparent px-[max(0px,calc(var(--ac-frame-bleed)_-_1px))] pb-[var(--ac-frame-pb)]';

export const isFeedSurface = (surface: Surface) =>
  surface === 'web_home' || surface === 'web_feeds';

// The surfaces that show a card under its own host row
export const isHomePreview = (surface: Surface) =>
  surface === 'web_home' ||
  surface === 'web_feeds' ||
  surface === 'mobile_home';

// Set as the frame's `data-mobile`, which switches the card's sizes to the phone column
export const phoneFrame = (surface: Surface) =>
  surface.startsWith('mobile_') || undefined;

export function cardFrame(surface: Surface) {
  if (surface.endsWith('_row'))
    return 'ac-scale w-full min-w-0 rounded-[calc(6*var(--ac-u))] px-[calc(8*var(--ac-u))] py-[calc(6*var(--ac-u))] hover:bg-surface-hover';
  if (isFeedSurface(surface)) return FEED_FRAME;
  if (surface === 'mobile_home')
    return 'ac-scale w-[calc(100%-35*var(--ac-u))] min-w-0 border-l pl-[calc(14*var(--ac-u))] mt-[calc(2*var(--ac-u))] mr-[calc(14*var(--ac-u))] mb-[calc(14*var(--ac-u))] ml-[calc(21*var(--ac-u))]';
  return CARD_FRAME;
}
